import React from 'react';
import "./Loader.css"

const Loader = () => {
    return (
        <div>
            <h1> Loading ... </h1>
        </div>
    );
};

export default Loader;